<app-traitement-data titre="EPAP" [sousTitre]="patient!.tableauDeBord?.epap?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.epap?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.epap?.value ?? 'Pas de donnée' }}
</app-traitement-data>